<template>
  <QuestionBoolean
    :text="content.great_grandfather_exist"
    :description="content.great_grandfather_exist_desc"
    :labelParentel="content.line_4_title"
    :preselect="store.parentel4.greatGrandfathersExist"
    @select="onSelect"
    @proceed="onProceed"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import QuestionMixin from '@/mixins/QuestionMixin';
import QuestionBoolean from '@/components/QuestionBoolean.vue';

export default {
  mixins: [QuestionMixin],
  components: {
    QuestionBoolean,
  },
  methods: {
    onSelect(value) {
      this.$store.commit('parentel4/setValue', {
        key: 'greatGrandfathersExist',
        value,
      });
    },
    onProceed() {
      const { partner, parentel4 } = this.store;

      if (parentel4.greatGrandfathersExist === false) {
        this.$store.dispatch('parentel4/resetSettings', 'greatGrandfather');
        let parentel = 4;

        if (parentel4.greatGrandmothersExist === false && partner.hasPartner) {
          parentel = 'partner';
        } else if (parentel4.greatGrandmothersExist === false) {
          parentel = 'country';
        }

        return this.$router.push({ path: '/savings', query: { parentel } });
      }
      return this.$router.push({ path: '/great-grandfather-count' });
    },
  },
  computed: {
    ...mapGetters(['store']),
  },
};
</script>

<style scoped>
</style>
